import { type CredentialsData, credentialsDataSchema } from '@si/types';
import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'src/useAuth';

import { queryKeys } from './queryKeys';

export function useCredentials() {
  const { authenticated, token } = useAuth();

  const {
    data: credentials,
    error,
    isLoading,
  } = useQuery<CredentialsData>({
    queryKey: queryKeys.getCredentials,
    queryFn: () => get({ url: '/user/account/credentials', schema: credentialsDataSchema }),
    enabled: authenticated || !!token,
  });

  return {
    credentials,
    error,
    isLoading,
  };
}
